import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { CommentCardProps } from './types';
import { COMMENTS_STYLES } from './styles';


export const CommentCard: React.FC<CommentCardProps> = ({ 
  comment, 
  className 
}) => {
  return (
    <Card
      className={className}
      sx={COMMENTS_STYLES.card}
      role="article"
      aria-labelledby={`comment-${comment.id}-title`}
      aria-describedby={`comment-${comment.id}-content`}
    >
      <CardContent sx={COMMENTS_STYLES.cardContent}>
        <Box sx={COMMENTS_STYLES.contentBox}>
          <Typography
            id={`comment-${comment.id}-content`}
            variant="body1"
            sx={COMMENTS_STYLES.contentText}
            aria-label={`Comment by ${comment.author}`}
          >
            {comment.content}
          </Typography>

          <Typography
            id={`comment-${comment.id}-title`}
            variant="body1"
            sx={COMMENTS_STYLES.authorText}
            component="cite"
            aria-label={`Author: ${comment.author}`}
          >
            {comment.author}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
